import createDecorator from 'final-form-focus'
import React, { useMemo } from 'react'
import { DocumentsButtons, DocumentsFileUploaderGroup } from '../'
import { DocumentsManualInfo } from '../DocumentsManualInfo/DocumentsManualInfo'
import { findInput } from 'components/Form/helpers'
import { Form } from 'react-final-form'
import { IDocumentsForm } from './interface'
import { InternationalDocumentCheck } from '../InternationalDocumentCheck/InternationalDocumentCheck'
import { OnboardingAsideMobile } from 'apps/Onboarding/components/OnboardingAsideMobile/OnboardingAsideMobile'
import { useDocumentsForm } from './hooks/useDocumentsForm'
import { useTranslation } from 'react-i18next'
import { useValidationsDocumentsForm } from './hooks/useValidationsDocumentsForm'
import './DocumentsForm.scss'

export const DocumentsForm = ({ files }: IDocumentsForm): JSX.Element => {
  const {
    additionalData,
    failUpload,
    handleDocumentSubmit,
    handleSubmit,
    hasInternationalDoc,
    hasKycProblem,
    isLoading,
    isLoadingFile,
    setHasInternationalDoc
  } = useDocumentsForm(files)
  const { fileMaxSizeAllowed, fileTypes, handleValidation } = useValidationsDocumentsForm(
    files,
    hasInternationalDoc,
    hasKycProblem,
    additionalData
  )
  const { t } = useTranslation()
  const focusOnError = useMemo(() => createDecorator(undefined, findInput), [])

  return (
    <Form
      decorators={[focusOnError]}
      onSubmit={handleSubmit}
      validate={handleValidation}
      render={({ errors, handleSubmit, hasValidationErrors, pristine, submitting, touched }): JSX.Element => (
        <form onSubmit={handleSubmit} className='documents-form'>
          {!hasKycProblem && (
            <>
              <p className='documents-form__description'>{t('wizard.documents.description').toString()}</p>
              <InternationalDocumentCheck checked={hasInternationalDoc} onChange={setHasInternationalDoc} />
              <DocumentsFileUploaderGroup
                {...{
                  failUpload,
                  fileMaxSizeAllowed,
                  fileTypes,
                  files,
                  handleDocumentSubmit,
                  hasInternationalDoc,
                  hasKycProblem,
                  isLoadingFile
                }}
              />
            </>
          )}
          {hasKycProblem && (additionalData.fiscal || additionalData.legal) && (
            <DocumentsManualInfo {...{ additionalData, errors, touched }} />
          )}
          <OnboardingAsideMobile />
          <DocumentsButtons
            {...{
              hasKycProblem,
              hasValidationErrors,
              isLoading,
              pristine,
              submitting
            }}
          />
        </form>
      )}
    />
  )
}
